import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  cancelDashboardOption,
  removeWorkspaceFromProject,
} from "../../state/workspaces/workspaces.actions";
import { selectSelectedWorkspace } from "../../state/workspaces/workspaces.selector";
import { useI18n } from "../../utils/hooks/use.i18n";
import { ConfirmationDialog } from "./ConfirmationDialog";

export const RemoveWorkspaceFromProjectDialog = () => {
  const dispatch = useDispatch();

  const t = useI18n("REMOVE_WORKSPACE_FROM_PROJECT_DIALOG.");

  const selectedWorkspace = useSelector(selectSelectedWorkspace);

  const submitClicked = () => {
    if (!selectedWorkspace?.containerId) return;
    if (!selectedWorkspace?.workspaceId) return;
    dispatch(
      removeWorkspaceFromProject.request({
        projectId: selectedWorkspace.containerId,
        workspaceId: selectedWorkspace.workspaceId,
      }),
    );
    dispatch(cancelDashboardOption());
  };

  return (
    <ConfirmationDialog
      buttonText={t("BUTTON")}
      cancelAction={() => dispatch(cancelDashboardOption())}
      icon="hoylu-ui-icons-x"
      message={t("MESSAGE", selectedWorkspace?.workspaceName)}
      submitAction={submitClicked}
      title={t("TITLE", selectedWorkspace?.workspaceName)}
    />
  );
};

export default RemoveWorkspaceFromProjectDialog;
